import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './css/global.css';
import App from './App';
import '@reach/skip-nav/styles.css';
import TagManager from 'react-gtm-module';
import { getGtmEnvVars } from './helpers';
import { CookiesProvider } from 'react-cookie';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const gtmSetup = async () => {
    let gtmArgs;

    await fetch('api/helper/getenvironment', {
        method: 'get',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then((res) => res.json())
        .then((envRes) => {
            const gtmId = 'GTM-KKNFC34';
            switch (envRes.environment.toLowerCase()) {
                case 'development':
                    gtmArgs = {
                        gtmId,
                        auth: 'qHHawehVfZqUXrjA2d0A7w',
                        preview: 'env-3'
                    };
                    break;
                case 'staging':
                    gtmArgs = {
                        gtmId,
                        auth: '5dDfLpjXQXAKx7cCdGfyvA',
                        preview: 'env-4'
                    };
                    break;
                case 'production':
                    gtmArgs = {
                        gtmId,
                        auth: 'JnQbaFhb6XngcyemaUvBug',
                        preview: 'env-1'
                    };
                    break;
                case 'local':
                default:
                    gtmArgs = {
                        gtmId,
                        auth: null,
                        preview: null
                    };
            }
        });

    TagManager.initialize(gtmArgs);
};
gtmSetup();

ReactDOM.render(
    <CookiesProvider>
        <BrowserRouter basename={baseUrl}>
            <App />
        </BrowserRouter>
    </CookiesProvider>,
    rootElement
);
